import React from "react"

import "./ProfileCard.css"
import strings from "../../../locales/ro.json"
import PersonalInfo from "./PersonalInfo/PersonalInfo";
import StatuteBelt from "./StatuteBelt/StatuteBelt";

const ProfileCard = () => {

	let quote = "aljdhfkuiahf ajsdnfijsfd jinafdsija jk kuiahf ajsdnfijsfd jinafdsija jk kuiahf ajsdnfijsfd jinafdsija jk owjnvcowj jansd";
	return (
		<div className="profileCardContainer">
			<PersonalInfo />
			<hr/>
			<StatuteBelt />
			<p className="quote">{quote}</p>
		</div>
	);
}

export default ProfileCard;